module.exports = __webpack_public_path__ + "static/img/case_tab_12.70c3366.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_tab_12.png
// module id = AtPD
// module chunks = 34